/**
 * Helper per la visualizzazione dei report: nascondono gli effetti dei retry
 * dello Stop dall'app. I dati restano su DB/S3, qui si filtra solo la vista.
 */

// I retry dello Stop dall'app possono caricare più foto Km_Finali sulla stessa
// sessione. Si tengono tutti gli start e, per ogni sessione, solo l'ultima
// Km_Finali (quella che l'ha chiusa davvero).
export const dedupKmPhotos = (photos: any[]): any[] => {
    if (!Array.isArray(photos) || photos.length <= 1) return photos || [];
    const tOf = (m: any) => new Date(m.uploadTime || m.dataAcquisizione).getTime();
    const sorted = [...photos].sort((a, b) => tOf(a) - tOf(b));
    const iniziali = sorted.filter(m => m.filename?.includes('Iniziali'));
    const finali = sorted.filter(m => m.filename?.includes('Finali'));
    const keptFinali: any[] = [];
    if (iniziali.length === 0) {
        if (finali.length) keptFinali.push(finali[finali.length - 1]);
    } else {
        iniziali.forEach((start, i) => {
            const startT = tOf(start);
            const nextT = i + 1 < iniziali.length ? tOf(iniziali[i + 1]) : Infinity;
            const inWin = finali.filter(f => tOf(f) >= startT && tOf(f) < nextT);
            if (inWin.length) keptFinali.push(inWin[inWin.length - 1]);
        });
    }
    return [...iniziali, ...keptFinali].sort((a, b) => tOf(a) - tOf(b));
};

// Due Stop consecutivi senza Start creano lato BE una sessione "degenerata"
// (durata ~0). La si fonde nella sessione precedente, prendendone i dati di
// chiusura più recenti. A DB resta comunque come traccia.
export const collassaSessioniDegenerate = (arr: any[]): any[] => {
    if (!Array.isArray(arr) || arr.length === 0) return arr;
    const sorted = [...arr].sort((a, b) => {
        const ta = a.startAt ? new Date(a.startAt).getTime() : 0;
        const tb = b.startAt ? new Date(b.startAt).getTime() : 0;
        return ta - tb;
    });
    const out: any[] = [];
    for (const s of sorted) {
        const dur = (s.startAt && s.endAt)
            ? new Date(s.endAt).getTime() - new Date(s.startAt).getTime()
            : null;
        const degenerata = dur !== null && dur < 2000; // < 2s = degenerata
        if (degenerata && out.length > 0) {
            const prev = out[out.length - 1];
            prev.endAt = s.endAt;
            if (s.endLat != null) prev.endLat = s.endLat;
            if (s.endLon != null) prev.endLon = s.endLon;
            if (s.fotoStopUrl) prev.fotoStopUrl = s.fotoStopUrl;
        } else {
            out.push({ ...s });
        }
    }
    return out;
};
